export default function useSegmentationSort() {
  const route = useRoute()

  const sortFields = ref<SegmentationSortFields>({})

  watch(
    () => route.query.sortFields,
    (newSortFields) => {
      sortFields.value = Object.fromEntries(new URLSearchParams(newSortFields ? String(newSortFields) : ''))
    },
    { immediate: true },
  )

  return { sortFields }
}
